const initialState = {
  submissionList: [],
};

export const submissionsReducer = (state = initialState, action) => {
  if (typeof action.execute === "function" && action.type === "submissions")
    return action.execute(state);
  return state;
};
